import React from 'react';
import { RouteComponentProps, useParams } from '@reach/router';
import { useQuery } from '@apollo/react-hooks';
import { loader } from 'graphql.macro';
import UserNav from './UserNavComponent';
import { simpleGTMDataLayer } from '../../util/GTMHelpers';
import useFeatureFlag from '../../util/hooks/useFeatureFlag';

const get_usernav_info = loader(
  './graphql/Get_UserNav_Info.graphql'
);

export default (_: RouteComponentProps) => {
  const { accountNumber } = useParams();
  const queryResult = useQuery(get_usernav_info, {
    variables: {
      account_number: accountNumber
    }
  });
  const { flagDetails: claimsUnavailableFlagDetails } = useFeatureFlag(
    'ClaimsUnavailable'
  );

  const { loading: isLoading, error, data } = queryResult;

  const accounts = data?.account?.items;
  const currentPage = window.location.pathname.split('/')[3];
  const onClick = (page: string) => {
    simpleGTMDataLayer({
      event: `click-${currentPage}NavTab`,
      page
    });
  };

  const props = {
    userDisplayName: (accounts && accounts[0]?.display_name) || 'Valued Agent',
    policies: accounts && accounts[0]?.policies?.items,
    accountNumber,
    isLoading,
    error,
    onClick,
    featureFlagStatuses: {
      claimsUnavailable: claimsUnavailableFlagDetails?.enabled
    }
  };

  return <UserNav {...props} />;
};
